import React, { useCallback, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getMatrixClient } from 'ducks/chat/utils/client'
import { selectIsBootstrapTypedInStates } from 'selectors/bootstrap/makeSelectIsBootstrapTypesLoaded'
import { selectFolderCollectionsByType } from 'ducks/folders/selectors/collections'
import { doBuildMenuFromWidgets } from 'ducks/folders/operations/collections'
import { subscribeSyncSearches } from 'ducks/searches/operations/subscribeSyncSearches'
import { subscribeChatBotState } from 'ducks/chat/operations/subscribeChatBotState'
import { selectIsMatrixClientReady } from 'ducks/chat/selectors/client'
import FolderCollection from './Collection'

export default function Folders({ type }) {
  const dispatch = useDispatch()
  const [hasTriggeredBootstrap, setHasTriggeredBootstrap] = useState(false)
  const collections = useSelector(state =>
    selectFolderCollectionsByType(state, type)
  )
  const isBootstrapped = useSelector(state =>
    selectIsBootstrapTypedInStates(
      state,
      ['folders', 'widgets', 'currentUser'],
      ['LOADED']
    )
  )
  const isMatrixClientReady = useSelector(selectIsMatrixClientReady)
  const onBootstrap = useCallback(
    client => {
      dispatch(doBuildMenuFromWidgets())
      dispatch(subscribeSyncSearches(client))
      dispatch(subscribeChatBotState(client))
    },
    [dispatch]
  )

  useEffect(
    () => {
      if (
        onBootstrap &&
        isBootstrapped &&
        !hasTriggeredBootstrap &&
        isMatrixClientReady
      ) {
        onBootstrap(getMatrixClient())
        setHasTriggeredBootstrap(true)
      }
    },
    [
      onBootstrap,
      isBootstrapped,
      hasTriggeredBootstrap,
      setHasTriggeredBootstrap,
      isMatrixClientReady,
    ]
  )

  return (
    <>
      {collections.map(({ id }) => (
        <FolderCollection key={id} collectionId={id} />
      ))}
    </>
  )
}
